// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3714 ? "fec483df" : chunkId) + "." + {"1867":"b27720facdfaf618","3714":"563dfec32fb8f3fe","4969":"ec8b0f59c277cb80","6885":"59b6759cf442cf4f","8288":"db54dd1955d4b9c6"}[chunkId] + ".js";
};